import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Observer, ReplaySubject, forkJoin, switchMap } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';

@Injectable({
    providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader {
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {

        return forkJoin([
            this._httpClient.get<Translation>(`./assets/i18n/${lang}.json`),
            this._httpClient.get<INFTItemsI18n[]>('./assets/json/nft-itemsi18n.data.json'),
            this._httpClient.get<Translation>(`./assets/i18n/spell/spell_${lang}.json`),
        ]).pipe(switchMap(r => {
            let nftItemsTranslation: Translation = {};
            r[1].forEach(t => {
                nftItemsTranslation[t.id] = {
                    name: t.i18n[lang].name,
                    description: t.i18n[lang].description
                }
            });
            let fullTranslation: Translation = {
                ...r[0], ...nftItemsTranslation, ...{ spell: r[2] }
            };
            return new Observable((observer: Observer<Translation>) => {
                observer.next(fullTranslation);
                observer.complete();
            })
        }));
        // return this._httpClient.get<Translation>(`./assets/i18n/${lang}.json`);
    }
}


interface INFTItemsI18n {
    id: string
    i18n: {
        en: {
            name: string
            description: string
        }
        it: {
            name: string
            description: string
        }
        es: {
            name: string
            description: string
        }
        pt: {
            name: string
            description: string
        }
        jp: {
            name: string
            description: string
        }
    }
}